import HeaderImage from "../../image/SCREEN1.png";
import "./header.css";

const Header = () => {
  return (
    <section id="header">
      <div className="container header__container">
        <div className="header__profile">
          <img
            width={1200}
            src={HeaderImage}
            style={{ maxWidth: '100%' }}
            alt="Header Portrait"
          />
        </div>
        <h3>Colour World </h3>
        <p></p>
        <h4 className="header_text">
          We stock the best products at
          <p> great prices, with expert advice.</p>
        </h4>
        <div className="header__cta">
          <a href="#contact" className="btn primary">
            Let's Talk
          </a>
          <a href="#product" className="btn light">
            Our Product
          </a>
        </div>
        <div className="header__social"></div>
      </div>
    </section>
  );
};

export default Header;
